import Layout, { LayoutContent } from '~/App/components/Layout'
import { Spinner } from '~/DesignSystem/components/spinner'

export const LayoutLoadingContent = () => {
  return (
    <LayoutContent className="flex items-center justify-center w-full h-full">
      <Spinner className="size-12" />
    </LayoutContent>
  )
}

const LoadingLayout = () => {
  return (
    <Layout>
      <LayoutLoadingContent />
    </Layout>
  )
}

export default LoadingLayout
